export default "__VITE_ASSET__VK1ExdgU__"